<template>
    <div class="form">
        <v-form
            ref="form"
            v-model="valid"
            lazy-validation
        >
            <v-layout>
                <v-flex xs12>
                    <v-layout row>
                        <v-flex md12>
                            <div class="content-wrapper">
                                <div class="info-block">
                                    Fill all information below
                                </div>
                            </div>
                        </v-flex>
                    </v-layout>
                    <v-layout row v-if="errors !== null">
                        <v-flex md12>
                            <div class="content-wrapper">
                                <div class="error-block">
                                    <div class="title">Errors</div>
                                    <p v-html="errors"></p>
                                </div>
                            </div>
                        </v-flex>
                    </v-layout>
                    <v-layout row justify-space-around>
                        <v-flex md6>
                            <div class="content-wrapper">
                                <v-layout row>
                                    <v-flex xs4>
                                        <div class="label text-xs-right">
                                            <span class="text-xs-right">Organization name<span class="required">*</span></span>
                                        </div>
                                    </v-flex>
                                    <v-flex xs8>
                                        <v-text-field
                                            label="Insert organization name"
                                            v-model="form.name"
                                            :rules="rules.name"
                                            required
                                            outline
                                            single-line
                                        ></v-text-field>
                                    </v-flex>
                                </v-layout>
                                <v-layout row>
                                    <v-flex xs4>
                                        <div class="label text-xs-right">
                                            <span class="text-xs-right">Time zone<span class="required">*</span></span>
                                        </div>
                                    </v-flex>
                                    <v-flex xs8>
                                        <v-select
                                            v-model="form.timeZone"
                                            :items="getTimeZones"
                                            :rules="rules.timeZone"
                                            label="Select a time zone"
                                            item-text="key"
                                            item-value="id"
                                            outline
                                            single-line
                                        ></v-select>
                                    </v-flex>
                                </v-layout>
                            </div>
                        </v-flex>
                        <v-flex md6>
                            <div class="content-wrapper">
                                <v-layout row>
                                    <v-flex xs4>
                                        <div class="label text-xs-right">
                                            <span class="text-xs-right">Support email</span>
                                        </div>
                                    </v-flex>
                                    <v-flex xs8>
                                        <v-text-field
                                            label="Insert support email"
                                            v-model="form.supportEmail"
                                            :rules="rules.supportEmail"
                                            outline
                                            single-line
                                        ></v-text-field>
                                    </v-flex>
                                </v-layout>
                                <v-layout row>
                                    <v-flex xs4>
                                        <div class="label text-xs-right">
                                            <span class="text-xs-right">Support phone number</span>
                                        </div>
                                    </v-flex>
                                    <v-flex xs8>
                                        <v-text-field
                                            label="Insert support phone number"
                                            v-model="form.supportPhoneNumber"
                                            :rules="rules.supportPhoneNumber"
                                            outline
                                            single-line
                                        ></v-text-field>
                                    </v-flex>
                                </v-layout>
                            </div>
                        </v-flex>
                    </v-layout>
                    <v-flex md6>
                        <div class="content-wrapper">
                            <v-layout row>
                                <v-flex xs4>
                                    <div class="label text-xs-right">
                                        <span class="text-xs-right">Licenses</span>
                                    </div>
                                </v-flex>
                                <v-flex xs8>
                                    <v-select
                                        label="Licenses"
                                        v-model="form.licenses"
                                        :items="getLicenses"
                                        item-text="key"
                                        item-value="id"
                                        multiple
                                        outline
                                        single-line
                                    ></v-select>
                                </v-flex>
                            </v-layout>
                        </div>
                    </v-flex>
                </v-flex>
            </v-layout>
            <v-layout row class="buttons">
                <v-flex xs6>
                    <sp-button @click.native="goBack" text="Go Back" small-icon icon="go-back" class="go-back"></sp-button>
                </v-flex>
                <v-flex xs6 class="right text-xs-right">
                    <div class="content-wrapper">
                        <sp-button @click.native="validate" text="Save" icon="download"></sp-button>
                    </div>
                </v-flex>
            </v-layout>
        </v-form>
    </div>
</template>

<script>
import { mapGetters } from 'vuex'
import SpButton from '@/components/forms/Button'
import router from '@/router/routes'

export default {
    name: 'OrganizationForm',
    components: {
        SpButton
    },
    props: {
        handler: {
            type: Function,
            required: true
        },
        form: {
            type: Object,
            required: true
        },
        isEditMode: {
            type: Boolean,
            default: false
        }
    },
    mounted () {
    },
    data () {
        return {
            valid: false,
            errors: null,
            rules: {
                name: [
                    v => (v === (v || '').trim()) || 'Organization name cannot have leading or trailing spaces',
                    v => (3 <= (v || '').trim().length && 100 >= (v || '').trim().length) || 'Organization name must be at least 3 and less than 100 characters'
                ],
                timeZone: [
                    v => !!v || 'Time zone cannot be empty'
                ],
                supportEmail: [
                    v => (0 === (v || '').trim().length || this.validateEmail(v)) || 'Invalid e-mail format.',
                    v => (v === (v || '').trim() || null === v) || 'Support email cannot have leading or trailing spaces',
                    v => ((3 <= (v || '').trim().length && 100 >= (v || '').trim().length) || 0 === (v || '').trim().length) || 'Support email can be empty or must be at least 3 and less than 100 characters'
                ],
                supportPhoneNumber: [
                    v => (0 === (v || '').trim().length || this.validatePhone(v)) || 'Invalid phone number format',
                    v => (v === (v || '').trim() || null === v) || 'Support phone number cannot have leading or trailing spaces',
                    v => ((3 <= (v || '').trim().length && 50 >= (v || '').trim().length) || 0 === (v || '').trim().length) || 'Support phone number can be empty or must be at least 3 and less than 50 characters'
                ]
            }
        }
    },
    computed: {
        ...mapGetters('dictionaryModule', [
            'getTimeZones',
            'getLicenses'
        ])
    },
    methods: {
        async validate () {
            this.valid = this.$refs.form.validate()
            if (!this.valid) {
                return false
            }

            try {
                this.errors = null
                await this.handler(this.form)
            } catch (e) {
                this.errors = e.message
            }
        },
        goBack () {
            router.back()
        },
        validateEmail (email) {
            let re = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
            return re.test(String(email).toLowerCase())
        },
        validatePhone (phone) {
            let re = /^([0-9+()\- ]+)$/
            return re.test(String(phone).toLowerCase())
        }
    }
}
</script>

<style scoped>

</style>
